import React from 'react';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Switch, Input, Alert, Button, Row, Col, InputNumber, message } from 'antd';
import { connect } from 'react-redux';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { withRouter } from 'react-router';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import BackButton from '../back_button/BackButton';
import { stockLocationsRestCrudThunksForSupplier } from '../../thunks/stock_locations_thunks';
import { getProtectedImageUriForSupplier } from '../../utils/FileAccessUtils';

import { equipmentsRestCrudThunksForSupplier } from '../../thunks/equipments_thunks';
import { equipmentPerStockLocationsRestCrudThunksForSupplier } from '../../thunks/equipment_per_stock_locations_thunks';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';

require('./StockLocationEquipmentsForm.less');

interface StockLocationEquipmentsFormProps extends FormComponentProps {
	formData: any;
	match: any;
	history: any;
	redirectForwardUrl?: string;
	onSuccess?: any;
	createErrors: any[];
	updateErrors: any[];
	currentUser: any;
	createBulk: any;
	create: any;
	update: any;
	fetchEquipment: any;
	fetchEquipments: any;
	fetchMultipleEquipments: any;
	equipments: any;
	getStockLocation: any;
}

class StockLocationEquipmentsForm extends React.Component<StockLocationEquipmentsFormProps, any> {
	state = {
		previewVisible: false,
		uploadLoading: false,
		previewImage: null,
		formDataInitialized: false,
		updating: false,
	};

	refreshStockLocation = () => {
		const { getStockLocation, match } = this.props;
		const stockLocationId = match.params.id;
		getStockLocation(stockLocationId);
	};

	handleSubmit = (e, submitAction) => {
		const { history, onSuccess, redirectForwardUrl } = this.props;
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				this.setState({ updating: true });
				const entities = values.equipmentsStockLocationKeys.map((equipmentsKey) => {
					if (values[`equipmentsStockLocation-${equipmentsKey}-equipmentId`]) {
						let equipment = values[`equipmentsStockLocation-${equipmentsKey}-equipment`] || {};
						return {
							id: values[`equipmentsStockLocation-${equipmentsKey}-id`],
							name: equipment.modelName,
							images: equipment.images,
							equipmentUUID: values[`equipmentsStockLocation-${equipmentsKey}-equipmentUUID`],
							equipmentId: values[`equipmentsStockLocation-${equipmentsKey}-equipmentId`],
							serialNumber: values[`equipmentsStockLocation-${equipmentsKey}-serialNumber`],
							cost: parseFloat(values[`equipmentsStockLocation-${equipmentsKey}-cost`]),
							isRental: values[`equipmentsStockLocation-${equipmentsKey}-isRental`],
							stockLocationId: values.id,
							supplierFacilityId: values.supplierFacilityId,
							supplierCompanyId: values.supplierCompanyId,
						};
					}
				});

				submitAction(entities).then(() => {
					if (redirectForwardUrl) {
						history.push(redirectForwardUrl);
					}
					if (onSuccess) {
						onSuccess(values.id);
					}
				});
			}
		});
	};

	addItem = (itemTypeVarName, uuid) => {
		const { form } = this.props;
		// can use data-binding to get
		const keys = form.getFieldValue(itemTypeVarName) || [];
		const nextKeys = keys.concat(uuid);
		// can use data-binding to set
		// important! notify form to detect changes
		form.setFieldsValue({
			[itemTypeVarName]: nextKeys,
		});
		return uuid + 1;
	};

	removeItem = (itemTypeVarName, k) => {
		const { form } = this.props;

		// can use data-binding to get
		const keys = form.getFieldValue(itemTypeVarName);

		// can use data-binding to set
		form.setFieldsValue({
			[itemTypeVarName]: keys.filter((key) => key !== k),
		});
	};

	previewEquipmentImage = (equipment) =>
		nullSafeGet('images', equipment) && equipment.images.length > 0
			? equipment.images.map((locImg) => {
					const [imgFileId, imgFileName] = locImg.split('/');
					return getProtectedImageUriForSupplier(imgFileId, imgFileName, 1200, 800);
			  })[0]
			: null;

	render() {
		const { form, createBulk, createErrors, formData, updateErrors, currentUser } = this.props;
		const { formDataInitialized } = this.state;
		const { getFieldDecorator, getFieldValue } = form;
		const submitAction = createBulk;
		const submitText = 'Update equipment';

		if (!formDataInitialized) {
			if (formData.equipmentsAtStockLocation) {
				let equipmentLines = formData.equipmentsAtStockLocation;
				formData.equipmentsStockLocationKeys = equipmentLines.map((el, idx) => idx);
				equipmentLines.forEach((lineItem, idx) => {
					formData[`equipmentsStockLocation-${idx}-id`] = lineItem.id;
					formData[`equipmentsStockLocation-${idx}-equipment`] = lineItem.equipment;
					formData[`equipmentsStockLocation-${idx}-equipmentId`] = lineItem.equipmentId;
					formData[`equipmentsStockLocation-${idx}-name`] = lineItem.name;
					formData[`equipmentsStockLocation-${idx}-equipment`] = lineItem.equipment;
					formData[`equipmentsStockLocation-${idx}-serialNumber`] = lineItem.serialNumber;
					formData[`equipmentsStockLocation-${idx}-cost`] =
						lineItem.cost || lineItem.equipment.cost;
					formData[`equipmentsStockLocation-${idx}-isRental`] = lineItem.isRental;
				});
			}
			this.setState({ formDataInitialized: true });
		}

		getFieldDecorator('supplierFacilityId', {
			initialValue: formData.supplierFacilityId || nullSafeGet('facility.id', currentUser),
		});
		getFieldDecorator('supplierCompanyId', {
			initialValue:
				formData.supplierCompanyId || nullSafeGet('facility.supplierCompanyId', currentUser),
		});

		getFieldDecorator('id', { initialValue: formData.id });

		getFieldDecorator('equipmentsStockLocationKeys', {
			initialValue: formData.equipmentsStockLocationKeys || [],
		});

		const equipmentsStockLocationKeys = getFieldValue('equipmentsStockLocationKeys');

		const equipmentsFormItems = equipmentsStockLocationKeys.map((k, equipmentsIndex) => {
			getFieldDecorator(`equipmentsStockLocation-${k}-equipmentId`, {
				initialValue: nullSafeGet(`equipmentsStockLocation-${k}-equipmentId`, formData),
			});
			getFieldDecorator(`equipmentsStockLocation-${k}-equipment`, {
				initialValue: nullSafeGet(`equipmentsStockLocation-${k}-equipment`, formData),
			});
			getFieldDecorator(`equipmentsStockLocation-${k}-equipmentUUID`, {
				initialValue: nullSafeGet(`equipmentsStockLocation-${k}-equipmentUUID`, formData),
			});
			getFieldDecorator(`equipmentsStockLocation-${k}-name`, {
				initialValue: nullSafeGet(`equipmentsStockLocation-${k}-name`, formData),
			});
			getFieldDecorator(`equipmentsStockLocation-${k}-isRental`, {
				initialValue: nullSafeGet(`equipmentsStockLocation-${k}-isRental`, formData),
			});
			return (
				<Row key={k} align="middle">
					{/* <Col span={1}>
						<Form.Item>{equipmentsIndex + 1}</Form.Item>
					</Col> */}

					{getFieldDecorator(`equipmentsStockLocation-${k}-equipmentId`, {
						initialValue: nullSafeGet(`equipmentsStockLocation-${k}-equipmentId`, formData),
					})}

					<Col span={9}>
						<Form.Item>
							<div
								className="equipmentStockLocationRowDisplay"
								style={{ justifyContent: 'space-between' }}
							>
								<div className="flex flex-col">
									<div className="equipmentStockLocationRowDisplay__rowTitle">
										<Ellipsis tooltip={true} length={40}>
											{nullSafeGet(`equipmentsStockLocation-${k}-name`, formData)}
										</Ellipsis>
									</div>
									<div className="equipmentStockLocationRowDisplay__rowSubtitle">
										<Ellipsis tooltip={true} length={40}>
											{nullSafeGet(`equipmentsStockLocation-${k}-equipment.modelName`, formData)}
										</Ellipsis>
										{nullSafeGet(
											`equipmentsStockLocation-${k}-equipment.equipmentTypeId`,
											formData
										) && (
											<>
												{`Equipment #${nullSafeGet(
													`equipmentsStockLocation-${k}-equipment.equipmentTypeId`,
													formData
												)}`}
											</>
										)}
									</div>
								</div>
							</div>
						</Form.Item>
					</Col>
					<Col span={3} offset={1}>
						<Form.Item>
							{getFieldDecorator(`equipmentsStockLocation-${k}-name`, {
								initialValue: nullSafeGet(`equipmentsStockLocation-${k}-name`, formData),
								validateTrigger: ['onBlur'],
							})(<Input style={{ width: '100%' }} />)}
						</Form.Item>
					</Col>
					<Col span={3} offset={1}>
						<Form.Item>
							{getFieldDecorator(`equipmentsStockLocation-${k}-serialNumber`, {
								initialValue: nullSafeGet(`equipmentsStockLocation-${k}-serialNumber`, formData),
								validateTrigger: ['onBlur'],
							})(<Input style={{ width: '100%' }} />)}
						</Form.Item>
					</Col>
					<Col span={2} offset={1}>
						<Form.Item>
							{getFieldDecorator(`equipmentsStockLocation-${k}-cost`, {
								initialValue: nullSafeGetOrElse(`equipmentsStockLocation-${k}-cost`, formData, 0),
								validateTrigger: ['onBlur'],
								rules: [
									{
										required: true,
										message: 'Please add cost.',
									},
								],
							})(<InputNumber style={{ width: '100%' }} />)}
						</Form.Item>
					</Col>
					<Col span={2} offset={1}>
						<Form.Item>
							{getFieldDecorator(`equipmentsStockLocation-${k}-isRental`, {
								initialValue: nullSafeGetOrElse(
									`equipmentsStockLocation-${k}-isRental`,
									formData,
									false
								),
								valuePropName: 'checked',
							})(<Switch />)}
						</Form.Item>
					</Col>
					<Col span={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						<Form.Item>
							{equipmentsStockLocationKeys.length > 0 ? (
								<MinusCircleOutlined
									translate=""
									className="dynamic-delete-button"
									onClick={() => this.removeItem('equipmentsStockLocationKeys', k)}
								/>
							) : null}
						</Form.Item>
					</Col>
				</Row>
			);
		});

		const equipmentsHeader = (
			<Row className="text-slate-500">
				{/* <Col span={1}>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					></div>
				</Col> */}
				<Col span={9}>
					<div className="flex flex-row justify-start">Equipment</div>
				</Col>
				<Col span={3} offset={1}>
					<div className="flex flex-row justify-center">Name</div>
				</Col>
				<Col span={3} offset={1}>
					<div className="flex flex-row justify-center">Serial Number</div>
				</Col>
				<Col span={2} offset={1}>
					<div className="flex flex-row justify-center">Cost</div>
				</Col>
				<Col span={2} offset={1}>
					<div className="flex flex-row justify-center">Is Rental</div>
				</Col>
				<Col span={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<div
						style={{
							padding: 12,
							marginTop: 16,
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					></div>
				</Col>
			</Row>
		);

		const equipmentsForm = (
			<div style={{ marginBottom: 32 }}>
				{equipmentsStockLocationKeys.length > 0 ? equipmentsHeader : null}
				{equipmentsFormItems}
			</div>
		);

		return (
			<Form
				layout="vertical"
				onSubmit={(e) => this.handleSubmit(e, submitAction)}
				className="supplierForm"
			>
				{createErrors.length > 0 ? (
					<Form.Item>
						<Alert message={createErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				{updateErrors.length > 0 ? (
					<Form.Item>
						<Alert message={updateErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				{equipmentsForm}
				<Form.Item>
					<Button
						type="primary"
						htmlType="submit"
						loading={this.state.updating}
						className="contactForm__button"
					>
						{submitText}
					</Button>
					<span style={{ marginLeft: '16px' }}>
						<BackButton buttonText="Cancel" />
					</span>
				</Form.Item>
			</Form>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	match: ownProps.match,
	formData: ownProps.formData,
	redirectForwardUrl: ownProps.redirectForwardUrl,
	onSuccess: ownProps.onSuccess,

	createErrors: state.stock_locations.createErrors,
	updateErrors: state.stock_locations.updateErrors,
	currentUser: state.session.currentUser,
	equipments: state.equipments,
});

const mapDispatchToProps = (dispatch) => ({
	createBulk: (entity) =>
		dispatch(equipmentPerStockLocationsRestCrudThunksForSupplier.createBulk(entity)),
	update: (entity) => dispatch(equipmentPerStockLocationsRestCrudThunksForSupplier.update(entity)),
	fetchEquipment: (id) => dispatch(equipmentsRestCrudThunksForSupplier.readOne(id)),
	fetchEquipments: (params, targetCollectionName) =>
		dispatch(equipmentsRestCrudThunksForSupplier.read(params, targetCollectionName)),
	fetchMultipleEquipments: (ids, targetCollectionName) =>
		dispatch(equipmentsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
	getStockLocation: (id) => dispatch(stockLocationsRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter<any, any>(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Form.create<StockLocationEquipmentsFormProps>()(StockLocationEquipmentsForm))
);
